import { useState, useEffect } from 'react';

const STORAGE_KEY = 'aec_compare';

/**
 * Shared compare list backed by localStorage.
 * Both AECLibrary and AECToolDetail use this hook so the selection
 * persists when navigating between the two pages.
 */
export function useCompareList() {
  const [compareList, setCompareList] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '[]');
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(compareList));
  }, [compareList]);

  const toggleCompare = (slug) =>
    setCompareList((prev) =>
      prev.includes(slug)
        ? prev.filter((x) => x !== slug)
        : prev.length < 3
        ? [...prev, slug]
        : prev
    );

  const clearCompare = () => setCompareList([]);

  return { compareList, toggleCompare, clearCompare };
}
